module.exports = __webpack_public_path__ + "img/googleplay-150x150.14035782.png";